import React from 'react';
import Box from '@mui/material/Box';
import Scrollbars from "react-custom-scrollbars-2"
import { SCROLLBAR } from "../../modules/constants"

export default function MainSection({ children, portrait }) {
  return (
    <Box
      id="main-section"
      sx={{
        flex: 1,
        display: 'flex',
        flexFlow: portrait ? 'column' : 'row',
        minHeight: portrait ? undefined : 0,
        overflowX: portrait ? 'hidden' : undefined,
        overflowY: portrait ? 'auto' : undefined,
      }}
    >
      {portrait ? (
        <Scrollbars autoHide autoHideTimeout={SCROLLBAR.AH_TIMEOUT} autoHideDuration={SCROLLBAR.AH_DURATION}>
          {children}
        </Scrollbars>
      ) : (
        children
      )}
    </Box>
  )
}